import Badge from 'components/Badge';
import React from 'react';
import { TagGroup } from 'types';

type ComponentProps = {
  stringLikeTagGroups: TagGroup[];
  badgeLikeTagGroups: TagGroup[];
  className?: string;
  handleDelete?: (group: TagGroup) => void;
};

const MixedTagGroupsLabels: React.FC<ComponentProps> = ({
  stringLikeTagGroups,
  badgeLikeTagGroups,
  className,
  handleDelete,
}) => (
  <div className={`flex flex-row flex-wrap items-center gap-1 ${className}`}>
    {stringLikeTagGroups &&
      stringLikeTagGroups.length > 0 &&
      stringLikeTagGroups.map((group, idx, arr) => (
        <div key={group.uuid}>
          {group.name}
          {(idx !== arr.length - 1 || badgeLikeTagGroups.length > 0) && ','}
        </div>
      ))}
    {badgeLikeTagGroups &&
      badgeLikeTagGroups.length > 0 &&
      badgeLikeTagGroups.map((group) => (
        <div key={group.uuid}>
          <Badge
            rounded={false}
            title={group.name || ''}
            colorClass="#FFC945"
            deleteAction={handleDelete ? (): void => handleDelete(group) : undefined}
          />
        </div>
      ))}
  </div>
);

export default MixedTagGroupsLabels;
